import { render, staticRenderFns } from "./asset-form.component.vue?vue&type=template&id=6758879d"
import script from "./asset-form.component.vue?vue&type=script&lang=js"
export * from "./asset-form.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports